export default __webpack_public_path__ + "static/media/coverOne.62dc70dd.svg";